import api from './index'

export async function getUserIdByEmail(
  token: string | null,
  email: string | null,
) {
  const impersonationPromise = await api
    .get(`/users?${encodeURI(`filter[email]=${email}`)}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
    .catch((err) => {
      console.error(err)
    })

  if (impersonationPromise && impersonationPromise.status == 200) {
    return impersonationPromise.data.data[0].id
  }

  return {}
}
